import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { breedFacts, images } from "../data/content";
import { Reveal } from "./Reveal";
export function Breed() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="race" className="bg-night py-24 lg:py-36" data-id="element-29" data-mp="2psig26o25rnn">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10" data-id="element-30" data-mp="2pqxngmlb0isf">
        <Reveal className="lg:col-span-5" data-id="element-31" data-mp="33ilyemjth17t">
          <img src={images.kitten} alt="Chaton Bengal à la robe brown rosetted" className="aspect-[4/5] w-full rounded-sm object-cover" data-id="element-32" data-mp="2zj3m2f629ygl" />
        </Reveal>

        <div className="lg:col-span-6 lg:col-start-7" data-id="element-33" data-mp="38j0786t8sf6w">
          <Reveal data-id="element-34" data-mp="38kb7vxre56ts">
            <h2 className="font-display text-4xl text-cream sm:text-5xl lg:text-6xl" data-id="element-35" data-mp="38hp0pz8ewtc3">
              Découvrir le <span className="italic text-sage" data-id="element-36" data-mp="1j6esnbs1puo5">Bengal</span>
            </h2>
            <p className="mt-6 max-w-lg leading-relaxed text-stone" data-id="element-37" data-mp="1e7brw3j3malz">
              Un léopard miniature au cœur de chat de salon. Voici l'essentiel à savoir avant d'accueillir un Bengal.
            </p>
          </Reveal>

          <div className="mt-12 border-b border-line" data-id="element-38" data-mp="2ze4ltik9uxa9">
            {breedFacts.map((f, i) => {
            const isOpen = open === i;
            return <div key={f.label} className="border-t border-line" data-id="element-39" data-mp="346e6aj2mb555" data-mpi={i}>
                  <h3 data-id="element-40" data-mp="394pfqsp03dmu">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`fact-${i}`} className="flex w-full items-center justify-between py-6 text-left" data-id="element-41" data-mp="393ecqv3dq9ws">
                      <span className="font-display text-2xl text-cream sm:text-3xl" data-id="element-42" data-mp="1oo2n7elntz1c">{f.label}</span>
                      <PlusIcon className={`h-5 w-5 text-sage transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} data-id="element-43" data-mp="1spo8noc9fln5" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-44" data-mp="2r2acfjf93p3u">
                    {isOpen && <motion.div id={`fact-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: "auto",
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-45" data-mp="351ru7eu4q23p">
                        <p className="max-w-lg pb-6 leading-relaxed text-stone" data-id="element-46" data-mp="3oo7lkq7qqi34">{f.value}</p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}